<template>
  <div>

    <h2>Farms</h2>
    <p class="text-danger"><strong>Important farm details. Please verify each of the attributes below is up-to-date and correct.</strong></p>

    <div class="clearfix" :style="{ width: widthForRow(getFieldValue('FARMS')) + 'px' }">
      <div v-for="farm in getFieldValue('FARMS')" class="farm-fields" :key="farm.id">
        <h3>
          <span class="form-group">
            {{ farm.farm_label }}
            <comments :field-name="`farm_${farm.id}-heading_farm_detail_label`" :isReadOnly="isReadOnly"></comments>
          </span>
        </h3>

        <text-input label="Supply"
                    :field-name="`farm_${farm.id}-supply_number`"
                    :disabled="isReadOnly">
        </text-input>

        <text-input label="Farm Name"
                    :field-name="`farm_${farm.id}-farm_name`"
                    :disabled="isReadOnly">
        </text-input>

        <number-input label="Farm Area (ha)"
                      :field-name="`farm_${farm.id}-farm_area_ha`"
                      :disabled="isReadOnly">
        </number-input>

        <select-input label="Shed Type"
                      :field-name="`farm_${farm.id}-shed_type`"
                      :disabled="isReadOnly"
                      :options="[
                                 {value: 'Rotary', display: 'Rotary'},
                                 {value: 'Herringbone', display: 'Herringbone'},
                                 {value: 'Robotic', display: 'Robotic'},
                                 ]">
        </select-input>

        <number-input label="Bales"
                      :field-name="`farm_${farm.id}-shed_bales`"
                      :disabled="isReadOnly">
        </number-input>

        <text-input label="Shed Address"
                    :field-name="`farm_${farm.id}-shed_address`"
                    :disabled="isReadOnly">
        </text-input>

        <text-input label="NAIT"
                    :field-name="`farm_${farm.id}-nait`"
                    :disabled="isReadOnly">
        </text-input>

        <text-input label="LIC"
                    :field-name="`farm_${farm.id}-lic_code`"
                    :disabled="isReadOnly">
        </text-input>

        <select-input label="Dairy rumination technology?"
                      field-name="rumination_tech_choice"
                      :farm-id="farm.id"
                      :disabled="isReadOnly"
                      :options="[
                                 {value: 'None', display: 'None'},
                                 {value: 'CowManager tags', display: 'CowManager tags'},
                                 {value: 'AllFlex collars', display: 'AllFlex collars'},
                                 {value: 'Halter collars', display: 'Halter collars'},
                                 {value: 'Other (please specify below)', display: 'Other (please specify below)'},
                                 ]">
        </select-input>
        <div class="alert alert-info">
          Please use the comment box to provide additional info. If 'other' is
          chosen please specify. Please also provide additional information
          after discussion with client: what do you like about your chosen
          technology? do you require additional resources? would you be willing
          to give your vet 3rd party access to your data?
        </div>

        <text-area label="Additional Information"
                    :field-name="`farm_${farm.id}-rumination_tech_details`"
                    :disabled="isReadOnly">
        </text-area>

      </div>
    </div>

    <modal v-if="showModal" @close="showModal = false">
    <h3 slot="header">Farming System</h3>
    <div slot="body">
      <table class="table table-bordered">
        <thead>
          <tr>
            <th width="33%">Farming System</th>
            <th width="66%">Description</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>System 1 - All grass self contained, all stock on the dairy platform.</td>
            <td>No feed is imported. No Supplement fed to the herd except
              supplement harvested off the effective milking area and dry cows
              are not grazed off the effective milking area.</td>
          </tr>
          <tr>
            <td>System 2 - Feed imported, either supplement or grazing off, fed to dry cows.</td>
            <td>Approx 4-14% of total feed is imported. Large variation in % as
              in high rainfall areas and cold climates such as Southland, most of
              the cows are wintered off.</td>
          </tr>
          <tr>
            <td>System 3 - Feed imported to extend lactation (typically autumna feed) and dry cows.</td>
            <td>Approx 10-20% of the total feed is imported. Westland - feed to
              extend lactation may be imported in spring rather than autumn.</td>
          </tr>
          <tr>
            <td>System 4 - Feed imported and used at both ends of lactation and for dry cows.</td>
            <td>Approx 20-30% of total feed is imported onto the farm.</td>
          </tr>
          <tr>
            <td>System 5 - Imported feed used all year, throughout lactation & for dry cows.</td>
            <td>Approx 25-40% (but can be up to 55%) of total feed is imported.</td>
          </tr>
        </tbody>
      </table>
    </div>
    </modal>

  </div>
</template>


<script>
import baseComponent from '@/mixins/base_consult_component_v2'
import Modal from '../Modal'

export default {
  name: 'FarmDetails',
  mixins: [ baseComponent ],
  components: {
    Modal,
  },
  data() {
    return {
      showModal: false,
    }
  },
};
</script>

<style>
.farm-fields {
  float: left;
  width: 350px;
  margin-right: 3em;
}

</style>
